import React, { createContext, useContext } from 'react';
const EditorContext = createContext<boolean>(false);
export function EditorProvider({
  value,
  children
}: {
  value: boolean;
  children: React.ReactNode;
}) {
  return <EditorContext.Provider value={value} data-id="element-202" data-mp="5wq88y0ifmac">{children}</EditorContext.Provider>;
}
export function useEditorPreview() {
  return useContext(EditorContext);
}